import { Type } from '../utils/type'
import { Any } from './Any'

export const StoreUser = Type('StoreUser', {
  id: Number,
  admin: Number,
  username: Any,
  email: String,
  firstName: String,
  surName: String,
  config: Object,
  country: String,
  city: String,
  hiddenFields: Object,
  created: String,
  updated: String,
})

export const makeStoreUser = ({
  id,
  admin,
  username,
  email,
  first_name: firstName,
  surname: surName,
  config,
  country,
  city,
  created_at: created,
  updated_at: updated,
}) => {
  const hide = config.hide || []

  return StoreUser(
    id,
    admin,
    username,
    email,
    firstName,
    surName,
    config,
    country,
    city,
    {
      cost: hide.indexOf('cost') != -1,
      users: hide.indexOf('users') != -1,
      sales: hide.indexOf('sales') != -1,
      media: hide.indexOf('media') != -1,
      edit: hide.indexOf('edit') != -1,
      voucher_code: hide.indexOf('voucher_code') != -1,
      find_influencers: hide.indexOf('find_influencers') != -1,
    },
    created,
    updated,
  )
}
